<template>
  <mcs-sheet
    outlined
    @click="$emit('click')"
  >
    <v-skeleton-loader
      v-if="loading"
      type="heading"
      class="d-flex mt-5 mb-3"
      style="width: 150px"
    />
    <div
      v-else
      class="d-flex"
    >
      <v-icon
        v-if="icon"
        size="32"
        class="mr-5"
        >{{ icon }}</v-icon
      >
      <div>
        <div class="body-1">{{ title }}</div>
        <div class="subtitle-1 mt-3 mb-3">
          {{ value }}
          <slot name="value"></slot>
        </div>
      </div>
    </div>
  </mcs-sheet>
</template>

<script>
export default {
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    icon: { type: String, default: '' },
    loading: Boolean
  }
};
</script>
